import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6349dd58"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = {
  key: 0,
  class: "errormessage general"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Ces informations vous permettront de vous identifier. Elles n'apparaîtront pas sur votre profil public", -1))
const _hoisted_4 = { class: "field-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Username" }, "Identifiant *", -1))
const _hoisted_6 = { class: "validity-icon" }
const _hoisted_7 = {
  key: 0,
  class: "errormessage"
}
const _hoisted_8 = { class: "field-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Email" }, "Email *", -1))
const _hoisted_10 = { class: "validity-icon" }
const _hoisted_11 = {
  key: 1,
  class: "errormessage"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Le mot de passe doit contenir au moins un caractère spécial et un chiffre. Il doit être de 8 caractères minimum", -1))
const _hoisted_13 = { class: "field-container" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "Password" }, "Mot de passe *", -1))
const _hoisted_15 = { class: "field-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "ConfirmPassword" }, "Confirmer le mot de passe *", -1))
const _hoisted_18 = { class: "validity-icon" }
const _hoisted_19 = {
  key: 0,
  class: "errormessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_loader_dots = _resolveComponent("loader-dots")!

  return (_openBlock(), _createElementBlock("form", {
    id: _ctx.id,
    class: "vertical"
  }, [
    (_ctx.error != '')
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("fieldset", null, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.username.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Username",
          onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ClearState('username'))),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SubmitUsername && _ctx.SubmitUsername(...args))),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SubmitUsername && _ctx.SubmitUsername(...args))),
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.username) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.username != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.username]
        ]),
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, [
          (_ctx.states.username == 'waitin')
            ? (_openBlock(), _createBlock(_component_loader_dots, {
                key: 0,
                id: "UsernameLoaderDots",
                type: "inline"
              }))
            : (_ctx.states.username == _ctx.NotFoundState)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icons.check.use()
                }, null, 8, ["icon"]))
              : (_ctx.states.username == _ctx.FoundState || _ctx.states.username == _ctx.ErrorState)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.SubmitUsername && _ctx.SubmitUsername(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.error.use()
                    }, null, 8, ["icon"]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.retry.use()
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.errors.username != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.errors.username), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.email.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Email",
          onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.ClearState('email'))),
          onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.SubmitEmail && _ctx.SubmitEmail(...args))),
          onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.SubmitEmail && _ctx.SubmitEmail(...args))),
          type: "email",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.email) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.email != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.email]
        ]),
        _hoisted_9,
        _createElementVNode("p", _hoisted_10, [
          (_ctx.states.email == 'waitin')
            ? (_openBlock(), _createBlock(_component_loader_dots, {
                key: 0,
                id: "EmailLoaderDots",
                type: "inline"
              }))
            : (_ctx.states.email == _ctx.NotFoundState)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icons.check.use()
                }, null, 8, ["icon"]))
              : (_ctx.states.email == _ctx.FoundState || _ctx.states.email == _ctx.ErrorState)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.SubmitEmail && _ctx.SubmitEmail(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.error.use()
                    }, null, 8, ["icon"]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.retry.use()
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.errors.email != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.errors.email), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("fieldset", null, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("p", null, [
          _createVNode(_component_font_awesome_icon, {
            icon: _ctx.icons.password.use()
          }, null, 8, ["icon"])
        ]),
        _withDirectives(_createElementVNode("input", {
          id: "Password",
          onFocus: _cache[10] || (_cache[10] = ($event: any) => (_ctx.ClearState('password'))),
          onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.SubmitPassword && _ctx.SubmitPassword(...args))),
          onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.SubmitPassword && _ctx.SubmitPassword(...args))),
          type: "password",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.password) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.password != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.password]
        ]),
        _hoisted_14
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _withDirectives(_createElementVNode("input", {
          id: "ConfirmPassword",
          onFocus: _cache[14] || (_cache[14] = ($event: any) => (_ctx.ClearState('password'))),
          onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.SubmitPassword && _ctx.SubmitPassword(...args))),
          onBlur: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.SubmitPassword && _ctx.SubmitPassword(...args))),
          type: "password",
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.confirm) = $event)),
          class: _normalizeClass({ 'valid': _ctx.formData.confirm != '' })
        }, null, 34), [
          [_vModelText, _ctx.formData.confirm]
        ]),
        _hoisted_17,
        _createElementVNode("p", _hoisted_18, [
          (_ctx.states.password == 'waitin')
            ? (_openBlock(), _createBlock(_component_loader_dots, {
                key: 0,
                id: "PasswordLoaderDots",
                type: "inline"
              }))
            : (_ctx.states.password == _ctx.NotFoundState)
              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icons.check.use()
                }, null, 8, ["icon"]))
              : (_ctx.states.password == _ctx.ErrorState)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.SubmitPassword && _ctx.SubmitPassword(...args)))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.error.use()
                    }, null, 8, ["icon"]),
                    _createVNode(_component_font_awesome_icon, {
                      icon: _ctx.icons.retry.use()
                    }, null, 8, ["icon"])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.errors.password != '')
        ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.errors.password), 1))
        : _createCommentVNode("", true)
    ])
  ], 8, _hoisted_1))
}